import { ElementRef, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HandoverHistoryDialogComponent } from '../components/handover-history/handover-history-dialog/handover-history-dialog.component';
import { ConfirmDialogComponent } from '../components/shared/confirm-dialog/confirm-dialog.component';
import { ExportDataDialogComponent } from '../components/shared/export-data-dialog/export-data-dialog.component';
import { HandoverDetailCommentsComponent } from '../components/shared/handover-detail-comments/handover-detail-comments.component';
import { HandoverHistoryObservationsDialogComponent } from '../components/shared/handover-history-observations-dialog/handover-history-observations-dialog.component';
import { ImageUploadComponent } from '../components/shared/image-upload/image-upload.component';
import { HandoverHistoryObservation } from '../interfaces/handover-observation';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  openCommentDialog(
    label: string,
    comments: string | undefined,
    target: ElementRef,
    topOffset: number,
    leftOffset: number,
    readOnlyContent?: boolean,
    maxLength?: number
  ): MatDialogRef<HandoverDetailCommentsComponent> {
    return this.dialog.open(HandoverDetailCommentsComponent, {
      width: '450px',
      disableClose: true,
      data: {
        label: label,
        comments: comments,
        target: target,
        topOffset: topOffset,
        leftOffset: leftOffset,
        readOnly: readOnlyContent ?? false,
        maxLength: maxLength,
      },
    });
  }

  openConfirmDialog(
    title: string,
    content: string,
    acceptText = 'Aceptar',
    cancelText = 'No, gracias'
  ): MatDialogRef<ConfirmDialogComponent> {
    return this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {
        title: title,
        content: content,
        acceptButtonText: acceptText,
        cancelButtonText: cancelText,
      },
    });
  }

  openImageUploadDialog(
    handoverId: number,
    title: string,
    dialogWidth = 500,
    hideDescription = false
  ): MatDialogRef<ImageUploadComponent> {
    return this.dialog.open(ImageUploadComponent, {
      width: dialogWidth + 'px',
      data: {
        handoverId: handoverId,
        title: title,
        hideDescription: hideDescription,
      },
    });
  }

  openSuccessDialog(
    title: string,
    content: string
  ): MatDialogRef<ConfirmDialogComponent> {
    return this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {
        title: title,
        content: content,
      },
    });
  }

  openHandoverHistoryObservationsDialog(
    title: string,
    observations: HandoverHistoryObservation[],
    emitterName: string,
    engineerEmitterName: string,
    handoverTypeId: number
  ): MatDialogRef<HandoverHistoryObservationsDialogComponent> {
    return this.dialog.open(HandoverHistoryObservationsDialogComponent, {
      width: '600px',
      height: 'auto',
      maxHeight: '500px',
      data: {
        observations: observations,
        title: title,
        emitterName: emitterName,
        engineerEmitterName: engineerEmitterName,
        handoverTypeId: handoverTypeId,
      },
    });
  }

  openHandoverHistoryDialog(
    wellId: string,
    wellCommonName: string,
    totalHandovers: number
  ): MatDialogRef<HandoverHistoryDialogComponent> {
    return this.dialog.open(HandoverHistoryDialogComponent, {
      width: '1024px',
      height: 'auto',
      maxHeight: '600px',
      data: {
        wellId: wellId,
        wellCommonName: wellCommonName,
        totalHandovers: totalHandovers,
      },
    });
  }

  openDHOExportDataDialog(): MatDialogRef<ExportDataDialogComponent> {
    return this.dialog.open(ExportDataDialogComponent, {
      width: '600px',
      height: 'auto',
      maxHeight: '600px',
    });
  }
}
